import { IStore } from 'store/configureStore';
import { selectCostCenterState } from 'modules/settings/submodules/clients/costCenters/store/selectors';

const selectEditCostCenterState = (state: IStore) => selectCostCenterState(state).editCostCenter;
export const selectEditCostCenterId = (state: IStore) => selectEditCostCenterState(state).costCenterId;
export const selectIsCostCenterUpdating = (state: IStore) => selectEditCostCenterState(state).isUpdating;
